"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.addToCalendarPropTypes = exports.ExpandDirectionTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _addToCalendar = _interopRequireDefault(require("@culturehq/add-to-calendar"));

var _DefaultButton = _interopRequireWildcard(require("../Button/DefaultButton"));

var _AddToCalendar = require("./AddToCalendar.style");

var ExpandDirectionTypes = {
  Up: 'up',
  Down: 'down'
};
exports.ExpandDirectionTypes = ExpandDirectionTypes;

var AddToCalendar = function AddToCalendar(_ref) {
  var title = _ref.title,
      description = _ref.description,
      location = _ref.location,
      startTime = _ref.startTime,
      endTime = _ref.endTime,
      buttonLabel = _ref.buttonLabel,
      filename = _ref.filename,
      showIcon = _ref.showIcon,
      handleClick = _ref.handleClick,
      expandDirection = _ref.expandDirection,
      variant = _ref.variant,
      as = _ref.as,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["title", "description", "location", "startTime", "endTime", "buttonLabel", "filename", "showIcon", "handleClick", "expandDirection", "variant", "as", "disabled"]);

  var event = {
    name: title,
    // name
    details: description,
    // details
    location: location,
    startsAt: startTime,
    // startsAt
    endsAt: endTime // endsAt

  };

  var ConditionalWrapper = function ConditionalWrapper(_ref2) {
    var disable = _ref2.disable,
        wrapper = _ref2.wrapper,
        children = _ref2.children;
    return disable ? children : wrapper(children);
  };

  var hasLabel = !!buttonLabel;
  return /*#__PURE__*/_react.default.createElement(_AddToCalendar.Wrapper, Object.assign({}, rest, {
    expandUp: expandDirection === ExpandDirectionTypes.Up,
    hasLabel: hasLabel
  }), /*#__PURE__*/_react.default.createElement(ConditionalWrapper, {
    disable: disabled,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/_react.default.createElement(_addToCalendar.default, {
        filename: filename,
        showIcon: false,
        handleClick: handleClick,
        event: event
      }, children);
    }
  }, /*#__PURE__*/_react.default.createElement(_DefaultButton.default, {
    startIcon: showIcon && 'Calendar',
    variant: variant,
    disabled: disabled
  }, buttonLabel)));
};

var addToCalendarPropTypes = {
  /** Title, which will show in calendars */
  title: _propTypes.default.string,

  /** Description, which will show in calendars */
  description: _propTypes.default.string,

  /** Location can be an address or a url */
  location: _propTypes.default.string,

  /** Event start time, validation must be done on consumer side. Expected format: '2016-09-16T20:15:00-04:00' */
  startTime: _propTypes.default.string.isRequired,

  /** Event end time, validation must be done on consumer side. Expected format: '2016-09-16T20:15:00-04:00' */
  endTime: _propTypes.default.string.isRequired,

  /** Optional Label for button, default is: "Add To Calendar" */
  buttonLabel: _propTypes.default.string,

  /** Optional name for file, default is: "download" */
  filename: _propTypes.default.string,

  /** Optional flag to show/hide the icon, default is: false */
  showIcon: _propTypes.default.bool,

  /** Optional function to control the onClick event */
  handleClick: _propTypes.default.func,

  /** Direction of options tray */
  expandDirection: _propTypes.default.oneOf(Object.values(ExpandDirectionTypes)),

  /** Button style */
  variant: _propTypes.default.oneOf(Object.values(_DefaultButton.ButtonType)),

  /** Button can or cannot be clicked */
  disabled: _propTypes.default.bool,

  /** An HTML tag used to render the component */
  as: _propTypes.default.string
};
exports.addToCalendarPropTypes = addToCalendarPropTypes;
AddToCalendar.propTypes = addToCalendarPropTypes;
AddToCalendar.defaultProps = {
  title: '',
  description: '',
  location: '',
  buttonLabel: 'Add To Calendar',
  filename: 'download',
  showIcon: false,
  handleClick: null,
  expandDirection: ExpandDirectionTypes.Down,
  variant: _DefaultButton.ButtonType.Primary,
  disabled: false,
  as: ''
};
var _default = AddToCalendar;
exports.default = _default;